"use client"

import "../globals.css"

import { NotFoundPage } from "@bullseye/ui"

export default NotFoundPage
